export default function mapProperties(obj, cb) {
  return Object.keys(obj).reduce((res, key) => {
    res[key] = cb(obj[key], key);
    return res;
  }, {});
}
